import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { authService } from '@/features/authentication/services/auth.service';
import { APP_ROUTES } from '@/shared/constants/routes.constants';

export interface GuestRouteProps {
  children: React.ReactNode;
}

/**
 * GuestRoute guard component
 * Protects routes that should only be accessible to non-authenticated users
 * (login, forgot password, reset password, verify code, etc.)
 * Redirects to modules page if user is already authenticated
 */
export const GuestRoute: React.FC<GuestRouteProps> = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = authService.isAuthenticated();

  if (isAuthenticated) {
    // Redirect to modules page (or the page they were trying to access before login)
    const from =
      (location.state as { from?: { pathname?: string } } | null)?.from?.pathname ??
      APP_ROUTES.MODULES;
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
};
